import { ChangeEvent, FC, Fragment } from 'react';
import { Blank, Button } from '@doda/io-react/common';
import { SearchCheckboxItem } from 'components/SearchCheckboxList';
import { JobCountQuery } from '@doda/common/src/services/getJobCountAPI';
import { OccupationHooksType } from 'components/SearchConditionSettingForm/types';
import styles from './index.module.scss';

/**
 * OccupationContentsのプロパティを定義するインターフェース
 */
interface Props {
  /** 職種フック */
  occupation: OccupationHooksType;
  /** 求人件数を更新する関数 */
  updateJobCount: (currentCondition?: JobCountQuery) => Promise<void>;
  /** モーダルを開くコールバック関数 */
  onClickOpenModal: () => void;
}

/**
 * OccupationContentsは職種の選択機能を提供するコンポーネント
 *
 * @param {Props} props - プロパティ
 * @returns {JSX.Element} - 職種コンテンツの要素
 */
export const OccupationContents: FC<Props> = ({
  occupation,
  updateJobCount,
  onClickOpenModal,
}) => {
  const {
    occupationDisplayList,
    updateIsCheckedOccupationLList,
    updateIsCheckedOccupationMList,
    updateIsCheckedOccupationSList,
  } = occupation;
  // 大分類のチェックボックス押下処理
  const onChangeLListCheckbox = (
    event: ChangeEvent<HTMLInputElement>,
    selectedId: string
  ) => {
    const checkedList = updateIsCheckedOccupationLList(event, selectedId);
    updateJobCount({ searchJobTypeLId: checkedList });
  };

  // 中分類のチェックボックス押下処理
  const onChangeMListCheckbox = (
    event: ChangeEvent<HTMLInputElement>,
    selectedId: string
  ) => {
    const checkedList = updateIsCheckedOccupationMList(event, selectedId);
    updateJobCount({ searchJobTypeMId: checkedList });
  };

  // 小分類のチェックボックス押下処理
  const onChangeSListCheckbox = (
    event: ChangeEvent<HTMLInputElement>,
    selectedId: string
  ) => {
    const checkedList = updateIsCheckedOccupationSList(event, selectedId);
    updateJobCount({ searchJobTypeSId: checkedList });
  };

  return (
    <div className={styles.searchConditionSettingForm__occupationContents}>
      <Button
        as="button"
        onClick={onClickOpenModal}
        size="S"
        variant="outline_gray"
      >
        職種を選択
        <Blank color="black" size="XS" />
      </Button>
      <div className={styles['occupation-check-list']}>
        {occupationDisplayList.map((occupationL) => (
          <Fragment key={occupationL.searchJobTypeId}>
            {occupationL.isDisplay && (
              <SearchCheckboxItem
                title={occupationL.name}
                value={occupationL.searchJobTypeId}
                isChecked={occupationL.isChecked}
                onChange={(event) =>
                  onChangeLListCheckbox(event, occupationL.searchJobTypeId)
                }
                size="L"
              />
            )}
            {occupationL.jobTypeMList.map((occupationM) => (
              <Fragment key={occupationM.searchJobTypeId}>
                {occupationM.isDisplay && (
                  <SearchCheckboxItem
                    title={occupationM.name}
                    isChecked={occupationM.isChecked}
                    value={occupationM.searchJobTypeId}
                    onChange={(event) =>
                      onChangeMListCheckbox(event, occupationM.searchJobTypeId)
                    }
                    size="L"
                  />
                )}
                {occupationM.jobTypeSList.map((occupationS) => (
                  <Fragment key={occupationS.searchJobTypeId}>
                    {occupationS.isDisplay && (
                      <div className={styles['occupation-check-list__small']}>
                        <SearchCheckboxItem
                          key={occupationS.searchJobTypeId}
                          title={occupationS.name}
                          isChecked={occupationS.isChecked}
                          value={occupationS.searchJobTypeId}
                          onChange={(event) =>
                            onChangeSListCheckbox(
                              event,
                              occupationS.searchJobTypeId
                            )
                          }
                          size="L"
                        />
                        <span
                          className={
                            styles['occupation-check-list__small__label']
                          }
                        >
                          <span>-</span>
                          {occupationM.name}
                        </span>
                      </div>
                    )}
                  </Fragment>
                ))}
              </Fragment>
            ))}
          </Fragment>
        ))}
      </div>
    </div>
  );
};
